import { FC, forwardRef } from 'react';
import { Dialog, DialogContent, IconButton, Slide } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { Paper, Close as CloseStyled, DialogText } from './FSModal.helper';

const Transition = forwardRef(function Transition(props: any, ref: any) {
  return <Slide direction="left" ref={ref} {...props} />;
});

export interface FSModalProps {
  modalIsOpen: boolean;
  backgroundColor?: string;
  width?: string;
  onClose: () => void;
  padding?: string;
  rounded?: string;
  closeBtn?: boolean;
  blur?: boolean;
  offsetTop?: string;
  slideDirection?: string;
  styles?: any;
  backdropColor?: string;
}

export const FSModal: FC<FSModalProps> = ({
  children,
  modalIsOpen,
  onClose,
  backgroundColor,
  width,
  padding,
  rounded,
  closeBtn = false,
  blur = false,
  offsetTop,
  slideDirection,
  styles,
  backdropColor,
}) => {
  const handleModalClose = () => onClose();
  const onCloseHandler = () => {
    onClose();
  };

  return (
    <Dialog
      sx={{
        paddingTop: offsetTop || '0px',
        zIndex: '1200',
        ...styles,
        ...(blur && {
          background: 'rgba(26, 21, 56, 0.6)',
        }),
      }}
      PaperComponent={Paper}
      PaperProps={{
        $backgroundColor: backgroundColor,
        $width: width,
        $padding: padding,
        $rounded: rounded,
        $overflowY: styles?.overflowY,
      } as any}
      onClose={onCloseHandler}
      open={modalIsOpen}
      onMouseUp={(e) => {
        e.stopPropagation();
      }}
      BackdropProps={{
        style: {
          backgroundColor: backdropColor || 'rgba(0, 0, 0, 0.5)',
        },
      }}
      TransitionComponent={slideDirection ? Transition : undefined}
      transitionDuration={slideDirection ? 600 : undefined}
    >
      {closeBtn && (
        <CloseStyled
          as={IconButton}
          type="button"
          aria-label="Close modal"
          onClick={handleModalClose}
          size="large"
        >
          <CloseIcon />
        </CloseStyled>
      )}

      <DialogText
        as={DialogContent}
        style={padding ? { padding } : {}}
        sx={styles}
      >
        {children}
      </DialogText>
    </Dialog>
  );
};
